import styles from './permission-denied-style.module.css';
import { Link } from "react-router-dom";

function PermissionDenied({path, accountData}) {

    return (
        <div id={styles.pd_background}>
            <div id={styles.pd_foreground}>
                <h1>Permission Denied</h1>
                <h2>You do not have access to this part of the website.</h2>
                <h3>If you believe that you should have access, please click the "Contact Us" link below.</h3>
                <div id={styles.button_panel}>
                    <Link to={`/contact?type=pd&path=${path}&accountId=${accountData.id}`}>Contact Us</Link>
                </div>                
            </div>           
        </div>
    );
}

export default PermissionDenied;